import React from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import ContactOne from './ContactOne';

const ContactMain = () => {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Navbar stays at the top */}
      <Navbar />

      {/* Main content grows to fill space */}
      <main className="flex-grow">
        <ContactOne />
      </main>

      {/* Footer sticks to bottom */}
      <Footer />
    </div>
  );
}

export default ContactMain;
